import {
  UVMapping,
  CubeReflectionMapping,
  CubeRefractionMapping,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  CubeUVReflectionMapping
} from "three";
export const MAPPINGS = [
  { UVMapping },
  { CubeReflectionMapping },
  { CubeRefractionMapping },
  { EquirectangularReflectionMapping },
  { EquirectangularRefractionMapping },
  { CubeUVReflectionMapping }
];
